(function () {
    'use strict';

    angular
        .module('emails')
        .controller('openCampaignHtmlController', openCampaignHtmlController);

    openCampaignHtmlController.$inject = ['$uibModalInstance', 'campaign'];

    function openCampaignHtmlController($uibModalInstance, campaign) {
        var vm = this;
        vm.campaign = campaign;
        vm.cancel = cancel;

        activate();

        function activate() {

        }

        function cancel () {
            $uibModalInstance.close();
        }
    }
})();